import { render, staticRenderFns } from "./CreateMoreWithhold.vue?vue&type=template&id=855dc290&scoped=true"
import script from "./CreateMoreWithhold.vue?vue&type=script&lang=js"
export * from "./CreateMoreWithhold.vue?vue&type=script&lang=js"
import style0 from "./CreateMoreWithhold.vue?vue&type=style&index=0&id=855dc290&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855dc290",
  null
  
)

export default component.exports